import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useContentMetadataGet = (contentId) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/content-document/${contentId}/metadata/`;
  return useRestQuery(requestUrl, { skip: !contentId });
};

export default useContentMetadataGet;
